import { FlexBox } from '@airship-platform/jam-web/components';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { NavLink } from 'react-router';
import { AppointmentHistory } from '../../../data-access/appointmentHistory';
import ScheduleCard from '../../schedule/components/ScheduleCard';
import SelectProposalButton from './SelectProposalButton';

interface ProposalTemplatesHistoryQueryListProps {
  templates: AppointmentHistory[];
}

const ProposalTemplatesHistoryQueryList: React.FC<
  ProposalTemplatesHistoryQueryListProps
> = ({ templates }) => (
  <FlexBox flexDirection={'column'} gap={2}>
    {templates.flatMap((template) =>
      template.proposals.map((p) => (
        <ScheduleCard
          key={p.appointmentProposalId}
          customer={{
            name: template.customerName,
            address: template.customerAddress.address1,
            city: template.customerAddress.city,
            state: template.customerAddress.state,
            zip: template.customerAddress.zip,
          }}
          appointment={{
            startDateTime: template.startDateTime,
            endDateTime: template.endDateTime,
          }}
          cardAction={
            <SelectProposalButton
              appointmentId={template.appointmentId}
              appointmentProposalId={p.appointmentProposalId}
            />
          }
        >
          <Typography variant={'body2'}>{p.optionsCount} options</Typography>
          <Link
            variant="body2"
            component={NavLink}
            to={{
              pathname: 'details',
              search: new URLSearchParams({
                appointmentId: template.appointmentId,
                appointmentProposalId: p.appointmentProposalId,
              }).toString(),
            }}
          >
            View details
          </Link>
        </ScheduleCard>
      ))
    )}
  </FlexBox>
);

export default ProposalTemplatesHistoryQueryList;
